import CandidateGroupTypes from 'redux/candidate-group/types';
import request from 'utils/request';
import urls from 'utils/config';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  createCandidateGroupSuccess,
  createCandidateGroupFailure,

  deleteCandidateGroupSuccess,
  deleteCandidateGroupFailure,

  editCandidateGroupSuccess,
  editCandidateGroupFailure,

  fetchCandidateGroupSuccess,
  fetchCandidateGroupFailure,
  updateCandidateGroupHeadersSuccess,
  updateCandidateGroupHeadersFailure,

} from 'redux/candidate-group/actions';
import { DEFAULT_ERROR_MESSAGE } from 'utils/constants';
import { errorNotifier, successNotifier } from 'utils/helpers';

const { API_BASE_URL } = urls || {};

function* createCandidateGroup({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/candidate-groups`;

  const response = yield request({ method: 'post', data, url });

  if (response.success) {
    yield put(createCandidateGroupSuccess(response.raw));
    successNotifier('Candidate group created successfully');
    cb();
  } else {
    yield put(createCandidateGroupFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to create candidate group');
  }
}

function* deleteCandidateGroup({ payload: { id, data, cb } }) {
  const url = `${API_BASE_URL}/candidate-groups/${id}`;

  const response = yield request({ method: 'delete', data, url });

  if (response.success) {
    yield put(deleteCandidateGroupSuccess(data));
    successNotifier('Candidate group deleted successfully');
    cb();
  } else {
    yield put(deleteCandidateGroupFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to delete candidate group');
  }
}

function* editCandidateGroup({ payload: { id, data, cb } }) {
  const url = `${API_BASE_URL}/candidate-groups/${id}`;

  const response = yield request({ method: 'put', data, url });

  if (response.success) {
    yield put(editCandidateGroupSuccess(response.raw));
    successNotifier('Candidate group updated successfully');
    cb();
  } else {
    yield put(editCandidateGroupFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to update candidate group');
  }
}

function* updateCandidateGroupTableHeaders({ payload: { id, data, cb } }) {
  const url = `${API_BASE_URL}/candidate-groups/${id}`;

  const response = yield request({ method: 'put', data, url });

  if (response.success) {
    yield put(updateCandidateGroupHeadersSuccess(response.raw));
    successNotifier('Candidate group headers updated successfully');
    cb();
  } else {
    yield put(updateCandidateGroupHeadersFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to update candidate group headers');
  }
}

function* fetchCandidateGroup({ payload: { data } }) {
  const safePageSize = data?.pageSize || 10;
  const pageNumber = data?.currentPage || 0;
  const name = data?.name || '';
  const url = `${API_BASE_URL}/candidate-groups?name=${name}&page=${pageNumber}&size=${safePageSize}`;

  const response = yield request({ method: 'get', url });
  if (response.success) {
    yield put(fetchCandidateGroupSuccess(response.raw));
  } else {
    yield put(fetchCandidateGroupFailure(DEFAULT_ERROR_MESSAGE));
    errorNotifier(response?.message || 'Unable to fetch candidate group');
  }
}


function* onCreateCandidateGroup() {
  yield takeLatest(
    CandidateGroupTypes.CREATE_CANDIDATE_GROUP,
    createCandidateGroup
  );
}

function* onDeleteCandidateGroup() {
  yield takeLatest(
    CandidateGroupTypes.DELETE_CANDIDATE_GROUP,
    deleteCandidateGroup
  );
}

function* onEditCandidateGroup() {
  yield takeLatest(
    CandidateGroupTypes.EDIT_CANDIDATE_GROUP,
    editCandidateGroup
  );
}

function* onUpdateCandidateGroupHeaders() {
  yield takeLatest(
    CandidateGroupTypes.UPDATE_CANDIDATE_GROUP_HEADERS,
    updateCandidateGroupTableHeaders
  );
}

function* onFetchCandidateGroup() {
  yield takeLatest(
    CandidateGroupTypes.FETCH_CANDIDATE_GROUP,
    fetchCandidateGroup
  );
}

export function* candidateGroupSagas() {
  yield all([
    call(onCreateCandidateGroup),
    call(onDeleteCandidateGroup),
    call(onEditCandidateGroup),
    call(onFetchCandidateGroup),
    call(onUpdateCandidateGroupHeaders),
  ]);
}
